export function EmojiPicker () {
  return import('../../emoji/emoji_picker');
}

export function Compose () {
  return import('../../compose');
}

export function HomeTimeline () {
  return import('../../home_timeline');
}

export function Firehose () {
  return import('../../firehose');
}

export function HashtagTimeline () {
  return import('../../hashtag_timeline');
}

export function Status () {
  return import('../../status');
}

export function GettingStarted () {
  return import('../../getting_started');
}

export function KeyboardShortcuts () {
  return import('../../keyboard_shortcuts');
}

export function PinnedStatuses () {
  return import('../../pinned_statuses');
}

export function AccountTimeline () {
  return import('../../account_timeline');
}

export function Reblogs () {
  return import('../../reblogs');
}

export function Favourites () {
  return import('../../favourites');
}

export function Quotes () {
  return import('../../quotes');
}

export function FollowRequests () {
  return import('../../follow_requests');
}

export function MateRequests () {
  return import('../../mate_requests');
}

export function FavouritedStatuses () {
  return import('../../favourited_statuses');
}

export function FollowedTags () {
  return import('../../followed_tags');
}

export function BookmarkedStatuses () {
  return import('../../bookmarked_statuses');
}

export function Blocks () {
  return import('../../blocks');
}

export function DomainBlocks () {
  return import('../../domain_blocks');
}

export function Mutes () {
  return import('../../mutes');
}

export function MuteModal () {
  return import('../components/mute_modal');
}

export function BlockModal () {
  return import('../components/block_modal');
}

export function DomainBlockModal () {
  return import('../components/domain_block_modal');
}

export function ReportModal () {
  return import('../components/report_modal');
}

export function IgnoreNotificationsModal () {
  return import('../components/ignore_notifications_modal');
}

export function MediaGallery () {
  return import('../../../components/media_gallery');
}

export function Video () {
  return import('../../video');
}

export function EmbedModal () {
  return import('../components/embed_modal');
}

export function ListAdder () {
  return import('../../list_adder');
}

export function Tesseract () {
  return import('tesseract.js');
}

export function Audio () {
  return import('../../audio');
}

export function OnboardingProfile () {
  return import('../../onboarding/profile');
}

export function CompareHistoryModal () {
  return import('../components/compare_history_modal');
}

export function Explore () {
  return import('../../explore');
}

export function MeHub () {
  return import('../../me_hub');
}

export function KronkOrgSpace () {
  return import('../../kronk_org');
}

export function Awawb () {
  return import('../../awawb');
}

export function FilterModal () {
  return import('../components/filter_modal');
}

export function InteractionModal () {
  return import('../../interaction_modal');
}

export function SubscribedLanguagesModal () {
  return import('../../subscribed_languages_modal');
}

export function ClosedRegistrationsModal () {
  return import('../../closed_registrations_modal');
}

export function NotificationRequests () {
  return import('../../notifications/requests');
}

export function NotificationRequest () {
  return import('../../notifications/request');
}

export function LinkTimeline () {
  return import('../../link_timeline');
}

export function AnnualReportModal () {
  return import('../components/annual_report_modal');
}

export function Orbit () {
  return import("../../activity");
}

export function Live () {
  return import("../../live");
}

export function LiveRoom () {
  return import("../../live/room");
}

export function Events () {
  return import("../../events").then(m => ({ default: m.Events }));
}

export function Nudges () {
  // Phase 1b: /nudges renders the Signal-shaped messenger shell.
  // Legacy features/nudges (partner-based 1:1 view) retires with the
  // legacy notification-bell view in the same sunset window.
  return import("../../nudges_messenger");
}

export function NudgesConversationSettings () {
  // Per-conversation settings surface — the Signal-shaped "chat info"
  // screen. Route: /nudges/:conversationId/settings.
  return import("../../nudges_messenger/conversation_settings");
}


export function EventDetail () {
  return import("../../events/event_detail").then(m => ({ default: m.EventDetail }));
}


export function Kommons () {
  return import("../../kommons").then(m => ({ default: m.Kommons }));
}

export function KommonsSettings () {
  return import("../../kommons/settings");
}

export function KommonsProposal () {
  return import("../../kommons/proposal_page").then(m => ({ default: m.ProposalPage }));
}

export function KommonsSpace () {
  return import("../../kommons/space_page").then(m => ({ default: m.SpacePage }));
}

export function KommonsNodeMeta () {
  return import("../../kommons/node_meta_page").then(m => ({ default: m.NodeMetaPage }));
}

export function KommonsProposePicker () {
  return import("../../kommons/propose_picker").then(m => ({ default: m.ProposePicker }));
}


export function KommonsLattice () {
  return import("../../kommons_lattice");
}


export function KronkSearch () {
  return import("../../kronk_search");
}


export function YouPortal () {
  return import("../../you_portal");
}


export function Questions () {
  return import("../../questions").then(m => ({ default: m.Questions }));
}

export function KuestionsSettings () {
  return import("../../questions/settings");
}

export function Booth () {
  return import("../../booth");
}

export function BoothSetPage () {
  return import("../../booth/booth_set_page");
}

export function ProfileSectionsSettings () {
  return import("../../profile_sections_settings").then(m => ({ default: m.ProfileSectionsSettings }));
}

export function ProfileSpace () {
  return import("../../profile");
}

export function ProfileSettingsPer () {
  return import("../../profile_settings_per").then(m => ({ default: m.ProfileSettingsPer }));
}

export function NudgesLegacyArchive () {
  return import("../../nudges_legacy").then(m => ({ default: m.NudgesLegacyArchive }));
}

export function Krews () {
  return import("../../krew").then(m => ({ default: m.Krews }));
}

export function Wachuneed () {
  return import("../../wachuneed");
}

export function WachuneedNew () {
  return import("../../wachuneed/new_listing");
}

export function WachuneedListingDetail () {
  return import("../../wachuneed/listing_detail");
}

export function KrewDetail () {
  return import("../../krew/krew_detail").then(m => ({ default: m.KrewDetail }));
}

export function KrewSettings () {
  return import("../../krew/krew_settings").then(m => ({ default: m.KrewSettings }));
}

export function Klot () {
  return import("../../klot").then(m => ({ default: m.Klot }));
}

export function Kommunity () {
  return import("../../kommunity").then(m => ({ default: m.Kommunity }));
}

export function KlotSettings () {
  return import("../../klot/settings");
}

export function Hub () {
  return import("../../hub").then(m => ({ default: m.Hub }));
}

export function Kalendar () {
  return import("../../kalendar");
}


export function InflowV2 () {
  return import("../../inflow_v2");
}

export function InflowVeil () {
  return import("../../inflow/veil");
}

export function FreeTheDream () {
  return import("../../freethedream");
}

export function MapV2 () {
  return import("../../map_v2");
}

export function Moments () {
  return import("../../moments").then(m => ({ default: m.Moments }));
}

export function MomentViewer () {
  return import("../../moments/viewer");
}

export function Albutts () {
  return import("../../albutts");
}

export function Art () {
  return import("../../art");
}

export function Kronikles () {
  return import("../../kronikles");
}

export function Cinema () {
  return import("../../cinema");
}

export function Rose () {
  return import("../../rose").then(m => ({ default: m.Rose }));
}

export function Karporn () {
  return import("../../karporn");
}

export function MapStub () {
  return import("../../korner_stub").then(m => ({ default: m.MapStub }));
}

export function KornerSettings () {
  return import("../../korner_settings").then(m => ({ default: m.KornerSettings }));
}

export function FeedSettings () {
  return import("../../feed_settings").then(m => ({ default: m.FeedSettings }));
}

export function StyleGuide () {
  return import("../../styleguide").then(m => ({ default: m.StyleGuide }));
}

export function Greeting () {
  return import("../../greeting").then(m => ({ default: m.Greeting }));
}

export function SettingsHub () {
  return import("../../settings_hub").then(m => ({ default: m.SettingsHub }));
}

export function AppearanceSettings () {
  return import("../../appearance_settings").then(m => ({ default: m.AppearanceSettings }));
}

export function PostingSettings () {
  return import("../../posting_settings");
}

export function NotificationsSettings () {
  return import("../../notifications_settings").then(m => ({ default: m.NotificationsSettings }));
}

export function AccountSettings () {
  return import("../../account_settings").then(m => ({ default: m.AccountSettings }));
}

export function DataSettings () {
  return import("../../data_settings").then(m => ({ default: m.DataSettings }));
}

export function PrivacySettings () {
  return import("../../privacy_settings").then(m => ({ default: m.PrivacySettings }));
}

export function SettingsYou () {
  return import("../../settings_you").then(m => ({ default: m.SettingsYou }));
}

export function SettingsKorners () {
  return import("../../settings_korners").then(m => ({ default: m.SettingsKorners }));
}

